import {Ic} from "../../../../models/common";
import {Range} from '../../../../common/Range';
import {IAppSpec} from "../../../../Redux/selector.state";
import {Validator_DcLED_BuckBoost} from './dcLED_buck_boost_validator';

export class Validator_DcLED_FloatingBuckBoost extends Validator_DcLED_BuckBoost {
  protected getIoutBounds(ic: Ic, spec: IAppSpec): Range {
    return new Range(Number.NEGATIVE_INFINITY, ic.iout_max);
  }
}
